<script lang="ts">
  import BaseButton from '../BaseButton/BaseButton.svelte';
  import type { ButtonLinkProps } from './types';
  const { ...props }: ButtonLinkProps = $props();
</script>

<BaseButton element="a" {...props} />
